import React from 'react';

import SlackLogoSvg from '../../images/slack.svg';

export const SlackLogo = () => {
  return <img height="18" src={SlackLogoSvg} alt="Slack logo" />;
};
